import React from "react";
import declension from "ati-core-utils/declension";
import Popup from "@components/popup";
import Button from "@components/button";
import Input from "@components/input";
import Field from "@components/field";
import { useStore } from "../../store";
import {
  HeaderPopupStyle,
  SubTitlePopup,
  PopupContentStyle,
  FooterWrapper,
} from "./Popup.styles";
import i18nStrings from "../../strings/stings";
import { roles } from "../../const";

export const advancePopup = () => {
  const { globalModule } = useStore();
  const strings = i18nStrings;
  const {
    email,
    limit,
    amount,
    handleChange,
    handleBlur,
    error,
    showAdvance,
    showSend,
    errorMessage,
    role,
  } = globalModule;
  const limitSeparate = (limits) => {
    const strLimit = limits.toString();
      const s = strLimit.length;
      const chars = strLimit.split("");
      const strWithSpaces = chars.reduceRight((acc, char, i) => {
          const spaceOrNothing = ((((s - i) % 3) === 0) ? " " : "");
          return (spaceOrNothing + char + acc);
      }, "");

      return ((strWithSpaces[0] === " ") ? strWithSpaces.slice(1) : strWithSpaces);
  };

  const getPopupTitle = () => {
    if (role === roles.carrier) return strings.getAdvance;
    if (role === roles.fuel) return strings.getFuel;
    return strings.getCredit;
  };

  const getPopupSubheader = () => {
    if (role === roles.carrier) return strings.indicateTheAlmost;
    if (role === roles.fuel) return strings.indicateRefuel;
    return strings.indicateHowMuch;
  };

  return (
    <Popup
      className="popup-main"
      onClose={() => showAdvance(false)}
    >
      <Popup.Header />
      <Popup.Content>
        <PopupContentStyle>
          <HeaderPopupStyle>{getPopupTitle()}</HeaderPopupStyle>
          <SubTitlePopup>{getPopupSubheader()}</SubTitlePopup>
          <div className="shape-filed">
            <Field
              className="label"
              label={strings.aplicationAmount}
              size="xxlarge"
            >
              <Input
                className="input-field"
                error={error.amount && errorMessage.amount}
                name="amount"
                placeholder={`${limitSeparate(limit)} ${declension(limit, strings.rubl)}`}
                value={amount}
                onBlur={handleBlur}
                onChange={(event) => handleChange(event.target.value, "amount")}
              />
            </Field>
          </div>
          <div className="shape-filed">
            <Field
              className="label"
              label={strings.yourEmail}
              size="xxlarge"
            >
              <Input
                className="input-field"
                error={error.email && errorMessage.email}
                name="email"
                placeholder="email@mail.com"
                value={email}
                onBlur={handleBlur}
                onChange={(event) => handleChange(event.target.value, "email")}
              />
            </Field>
          </div>
        </PopupContentStyle>
      </Popup.Content>
      <FooterWrapper>

        <Popup.Footer
          theme="white"
        >
          <Popup.ActionWrapper
            className="footer"
          >
            <Button theme="primary" onClick={() => showSend(true, "advance")}>
              {strings.submitAnAplication}
            </Button>
          </Popup.ActionWrapper>
        </Popup.Footer>
      </FooterWrapper>
    </Popup>
  );
};
